export default __webpack_public_path__ + "static/media/logo-mcti.51a9723c.png";